/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export class FbdbSetting {
	public crewSizesEnabled?: boolean;

	constructor(data = {}) {
		Object.assign(this, data);
	}
}
